<div
	class="sidebar-next-right-block main-merchant layout-location root-body-sidebar-slim custom-w"
>
	<div class="title-header mb-4">Insights</div>
	<mat-tab-group mat-stretch-tabs="false">
		<mat-tab label="Products">
			<ng-template matTabContent>
				<partner-insights-reports></partner-insights-reports>
			</ng-template>
		</mat-tab>

		<mat-tab label="Delivery" [disabled]="true"> </mat-tab>
	</mat-tab-group>
</div>

<p-toast position="top-right"></p-toast>
